<template>
  <chat-content-empty
    icon="forum"
    :title="$t('entities.chat.message.notSelected.title')"
    :show-channels="showChannels"
  >
    <template v-slot:text>
      <tm-translate keypath="entities.chat.message.notSelected.text">
        <template v-slot:action>
          <tm-button
            class="primary--text"
            text-link
            :disable="disabled"
            @click="$emit('action')"
          >
            {{ $t('entities.chat.message.notSelected.action') }}
          </tm-button>
        </template>
      </tm-translate>
    </template>
  </chat-content-empty>
</template>

<script setup lang="ts">
import TmTranslate from '@/components/TmTranslate.vue'
import TmButton from '@/components/shared/TmButton.vue'
import ChatContentEmpty from '@/components/domain/chats/content/contentEmpty/ChatContentEmpty.vue'

defineProps<{
  showChannels?: boolean
  disabled?: boolean
}>()

defineEmits<{
  action: []
}>()
</script>
